export default "__VITE_ASSET__ByuuBOMf__"